<div class="content-div">
  <div class="paragraph">
    <mat-card appearance="outlined">
      <mat-card-header>
        <h1>Japanese and Me</h1>
      </mat-card-header>
      <mat-card-content>
        <p>
          From 2007 until 2013, I was self-taught in Japanese and passed the
          <a href="https://www.jlpt.jp/e/faq/index.html">JLPT</a> N5 and N4
          exams. Once I started college, I chose Japanese as a minor. In
          December of 2015, I passed the JLPT N3 exams as part of a class I
          took. The Japanese language and Culture has been a long time passion
          of mine.
        </p>
      </mat-card-content>
    </mat-card>
  </div>
  <div class="image-div">
    <mat-card appearance="outlined" class="testy2">
      <mat-card-content>
        <img
          alt="jlpt-n5-score"
          mat-card-image
          class="jlpt-score"
          src="https://firebasestorage.googleapis.com/v0/b/jlz-portfolio.appspot.com/o/hobbies%2Fjlpt%2FJLPTN5.jpeg?alt=media&token=e7de8019-ef0e-4f23-8a34-31d08f63ead9"
        />
        <caption>
          Certificate of Passing JLPT N5
        </caption>
      </mat-card-content>
    </mat-card>
    <mat-card appearance="outlined" class="testy2">
      <mat-card-content>
        <img
          alt="jlpt-n4-score"
          mat-card-image
          class="jlpt-score"
          src="https://firebasestorage.googleapis.com/v0/b/jlz-portfolio.appspot.com/o/hobbies%2Fjlpt%2FJLPTN4.jpeg?alt=media&token=d1094cf1-e6ae-4c92-b248-c9ed75940045"
        />
        <caption>
          Certificate of Passing JLPT N4
        </caption>
      </mat-card-content>
    </mat-card>
    <mat-card appearance="outlined" class="testy2">
      <mat-card-content>
        <img
          alt="jlpt-n3-score"
          mat-card-image
          class="jlpt-score"
          src="https://firebasestorage.googleapis.com/v0/b/jlz-portfolio.appspot.com/o/hobbies%2Fjlpt%2FJLPTN3.jpeg?alt=media&token=8a9e7a7b-45bd-458d-ad50-9f040ef2db90"
        />
        <caption>
          Online Report of Passing JLPT N3
        </caption>
      </mat-card-content>
    </mat-card>
  </div>
  <div class="paragraph">
    <mat-card appearance="outlined">
      <mat-card-header>
        <h1>2011 Trip To Japan</h1>
      </mat-card-header>
      <mat-card-content>
        <p>
          I've been to Japan once and it was an incredible adventure. I need to
          go back! I traveled to Tokyo, Kyoto, and Hiroshima. Below you'll find
          various photos from all 3 prefectures. I got to ride Shinkansen
          (Bullet Trains), see temples, and enjoy ordering Starbucks in
          Japanese!
        </p>
      </mat-card-content>
    </mat-card>

    <!-- <app-carousel [slides]="japanPics"></app-carousel> -->
  </div>
</div>
